import React from 'react';
import classes from './ProductInfo.module.scss';

const ProductInfo = (props) => {
    // let blockCertification = null;
    // if (props.data_certificate.length > 0) {
    //     let listCertification = props.data_certificate.map(item => {
    //         return (<li key={item.id}><img src={item.certificate} alt={item.name}/></li>)
    //     });
    //     blockCertification = (
    //         <div className={classes.ProductInfo_rowCertifications}><h4>CERTIFICATIONS</h4>
    //             <ul className={classes.ProdCertification_wrapper}>
    //                 {listCertification}
    //             </ul>
    //         </div>
    //     )
    // }

    return (
        <div className={classes.ProductInfo_container}>
            <div className={classes.ProductInfo_rowInfo}>
                <div className={"jbfs-list"} dangerouslySetInnerHTML={{__html: props.data.description}}/>
            </div>
            {/*{blockCertification}*/}
            {props.data_certificate && props.data_certificate.length > 0 ? (
                <div className={classes.ProductInfo_rowCertifications}><h4>CERTIFICATIONS</h4>
                    <ul className={classes.ProdCertification_wrapper}>
                        {props.data_certificate.map((item, index) => {
                            return (<li key={`${item.product_certi_cd}${index}`}><img src={item.certificate} alt={item.name}/></li>)
                        })}
                    </ul>
                </div>
            ) : ''}
        </div>
    );
}

export default ProductInfo;